export function questionnaireEmptyMessage(isPending: boolean, isError: boolean): string {
  if (isError) return '問診票を取得できませんでした。再度開いてください。';
  if (isPending) return '問診票を読み込み中...';
  return '問診票が未設定です。問診票を生成してください。';
}
